module.exports = __webpack_public_path__ + "img/KUCE_05.d08222b2.png";